import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { FormController } from '@adornis/forms/x-form-controller.js';
import { allTinyMCEPlugins } from '@adornis/writer/x-tinymce.js';
import { CampusNotification } from '@chancenwerk/db/notifications/CampusNotification.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { switchMap } from 'rxjs';
import { campusTinyPluginJumpMarks } from '../tinyPlugins/campus-tiny-plugin-jumpmarks.js';

@customElement('campus-dialog-edit-notification')
export class CampusDialogEditNotification extends ChromiumDialog<void> {
  static override get element_name() {
    return 'campus-dialog-edit-notification';
  }

  @property({ attribute: false }) public notification = new RXController(this, new CampusNotification({}));
  @state() private readonly _notificationDirty = new RXController(
    this,
    this.notification.observable.pipe(switchMap(notification => notification.dirty)),
  );

  override heading = 'Neuigkeit bearbeiten';

  private readonly _form = new FormController(this, this.notification.observable, {
    success: async notification => {
      if (notification._id) {
        await notification.save();
      } else {
        await notification.create();
      }
      await this.close();
    },
  });

  override content() {
    return html`
      <cr-flex space="md" padding="md">
        <cr-input placeholder="Überschrift" ${this._form.field('title')}></cr-input>
        <x-tinymce
          ${this._form.field('content')}
          menubar="false"
          editable
          minheight="50vh"
          placeholder="Inhalt"
          .editorOptions=${{
            convert_urls: false,
            plugins: [...allTinyMCEPlugins, 'campus-tiny-plugin-jumpmarks'],
            toolbar:
              'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent lineheight | numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen | campus-tiny-plugin-jumpmarks insertfile image media template link anchor codesample | ltr rtl | table tablemergecells',
          }}
          .customPlugins=${[campusTinyPluginJumpMarks]}
        ></x-tinymce>
      </cr-flex>
    `;
  }

  override footerContent() {
    return html`
      <cr-flex horizontal crossaxis-center end space="md">
        <campus-delete-button
          @click=${async () => {
            if (await ChromiumDialog.confirm('Neuigkeit wirklich löschen?', { highlightDecline: true })) {
              await this.notification.value.remove();
              this.close();
            }
          }}
        ></campus-delete-button>
        <cr-button
          icon="save"
          @click=${async () => {
            await ChromiumDialog.guard(() => this._form.validate());
          }}
        >
          Speichern
        </cr-button>
      </cr-flex>
    `;
  }

  public override async cancel() {
    if (this._notificationDirty.value && this.notification.value._id) {
      if (!(await ChromiumDialog.confirm('Ungespeicherte Änderungen verwerfen?'))) return;
      if (this.notification.value._id) this.notification.value.revert();
    }
    await super.cancel();
  }
}
